import { render, staticRenderFns } from "./ExtratoFaturaVlrAplicacao.vue?vue&type=template&id=7ea054bd&scoped=true&"
import script from "./ExtratoFaturaVlrAplicacao.vue?vue&type=script&lang=js&"
export * from "./ExtratoFaturaVlrAplicacao.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoFaturaVlrAplicacao.vue?vue&type=style&index=0&id=7ea054bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea054bd",
  null
  
)

export default component.exports